import { NativeRequestType } from "@swiggy-private/native-bridge";
import { isEmpty } from "@swiggy-private/js-utils";

const JUSPAY_NATIVE_BRIDGE_TYPES = new Set<NativeRequestType>([
    NativeRequestType.IS_JUSPAY_AVAILABLE,
    NativeRequestType.JUSPAY_INIT,
    NativeRequestType.INIT_JUSPAY_WALLET,
    NativeRequestType.PAY_USING_JUSPAY_NB,
    NativeRequestType.PAY_USING_SAVED_CARD,
    NativeRequestType.PAY_USING_JUSPAY_NEW_CARD,
    NativeRequestType.PAY_USING_JUSPAY_WALLET,
    NativeRequestType.PAY_USING_JUSPAY_WALLET_CRED,
    NativeRequestType.GET_INAPP_UPI_ACCOUNT_LIST,
    NativeRequestType.ONBOARD_INAPP_UPI,
    NativeRequestType.ADD_NEW_BANK_INAPP_UPI,
    NativeRequestType.INITIATE_INAPP_UPI_ONBOARDING,
    NativeRequestType.ADD_NEW_INAPP_UPI,
    NativeRequestType.PAY_USING_INAPP_UPI,
    NativeRequestType.MANAGE_IN_APP_UPI,
]);

export function isJuspayNativeBridgeType(type: NativeRequestType): boolean {
    return JUSPAY_NATIVE_BRIDGE_TYPES.has(type);
}

interface JuspayNativeBridgeMidPayload {
    merchantId?: string;
    mid?: string;
    juspayParams?: {
        merchantId?: string;
    };
}

export function getJuspayMidFromNativeBridgePayload(payload: unknown): string | undefined {
    if (isEmpty(payload)) {
        return undefined;
    }

    const requestPayload = payload as JuspayNativeBridgeMidPayload;

    return requestPayload.merchantId ?? requestPayload.mid ?? requestPayload.juspayParams?.merchantId;
}
